export const NONE = 'None'
